import { render, staticRenderFns } from "./UptodateGraphic.vue?vue&type=template&id=67ac7f40&scoped=true"
import script from "./UptodateGraphic.vue?vue&type=script&lang=js"
export * from "./UptodateGraphic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac7f40",
  null
  
)

export default component.exports